import { EN_PLATFORM_TYPE_DEUS, EN_PLATFORM_TYPE_FROM_CLIENT } from '@@sapporo/constant/enum/EN_DEVICE_TYPE';
import { IRequestWrap } from '@/server/IServer';
import { includes, propOr } from 'ramda';
import { UAParser } from 'ua-parser-js';

enum EN_PLATFORM {
  PC_WEB = 'WEB',
  MOBILE_WEB = 'MOBILE_WEB',
}

export interface IPlatform {
  toExhibition(): EN_PLATFORM_TYPE_DEUS;
  toHeader(): EN_PLATFORM_TYPE_FROM_CLIENT;
  toString(): string;
}

/**
 * 요청 받은 플랫폼을 가져온다.
 * user agent에서 device를 획득하지 못할 경우 기본값을 PC로 반환한다.
 * @param req
 * @return IPlatform
 */
export function getPlatform(ua: UAParser): IPlatform {
  const deviceType: string = propOr('', 'type', ua.getDevice());

  const platform: EN_PLATFORM = includes(deviceType, ['mobile', 'tablet'])
    ? EN_PLATFORM.MOBILE_WEB
    : EN_PLATFORM.PC_WEB;

  return {
    toExhibition() {
      return platform === EN_PLATFORM.PC_WEB ? EN_PLATFORM_TYPE_DEUS.PW : EN_PLATFORM_TYPE_DEUS.MW;
    },
    toHeader() {
      return platform === EN_PLATFORM.PC_WEB ? EN_PLATFORM_TYPE_FROM_CLIENT.PW : EN_PLATFORM_TYPE_FROM_CLIENT.MW;
    },
    toString() {
      return platform === EN_PLATFORM.PC_WEB ? 'PC_WEB' : 'MOBILE_WEB';
    },
  };
}

/**
 * 요청 받은 플랫폼을 가져온다.(서버 상에서)
 * user agent에서 device를 획득하지 못할 경우 기본값을 PC로 반환한다.
 * @param req
 * @return TPlatform
 */
export function getPlatformOnServer(req: IRequestWrap): IPlatform {
  const { ua }: { ua: UAParser } = req;

  return getPlatform(ua);
}

export function getPlatformOnClientAndServer(req?: IRequestWrap): IPlatform {
  return req ? getPlatformOnServer(req) : getPlatform(new UAParser());
}
